import 'bootstrap/js/dist/collapse';

export default class RecallPage {
    constructor() {
        $(document).ready(() => {

            const accordions = document.querySelectorAll(".accordionItem");

            const openAccordion = (accordion) => {
                const content = accordion.querySelector(".accordionBody");
                accordion.classList.add("active");
                content.style.maxHeight = `${content.scrollHeight}px`;
            };

            const closeAccordion = (accordion) => {
                const content = accordion.querySelector(".accordionBody");
                accordion.classList.remove("active");
                content.style.maxHeight = '0';
            };

            accordions.forEach((accordion) => {
                const header = accordion.querySelector(".accordionHeader");

                header.onclick = () => {
                    if (accordion.classList.contains("active")) {
                    closeAccordion(accordion);
                    } else {
                    accordions.forEach((item) => {
                        closeAccordion(item)
                    });
                    openAccordion(accordion);
                    }
                };
            });

            window.onresize = () => {
              accordions.forEach((accordion) => {
                if (accordion.classList.contains("active")) {
                  const content = accordion.querySelector(".accordionBody");
                  const height = content.querySelector('.accordionBody-inner')?.scrollHeight;
                content.style.maxHeight = `${height}px`;
                }
              });
            }
        });
    }
}